import {
  Button,
  Create,
  required,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  useRedirect,
} from "react-admin";
import CancelIcon from "@mui/icons-material/Cancel";

const ProviderCreateToolbar: React.FC = (props) => {
  const redirect = useRedirect();
  return (
    <Toolbar {...props}>
      <SaveButton />
      <Button
        variant="outlined"
        color="warning"
        label="Annuler"
        size="large"
        onClick={() => redirect("list", "providers")}
        sx={{ ml: 2, pl: 4 }}
      >
        <CancelIcon />
      </Button>
    </Toolbar>
  );
};

export const ProviderCreate = () => (
  <Create
    resource="providers"
    redirect="list"
    title="Créer un nouveau prestataire"
  >
    <SimpleForm toolbar={<ProviderCreateToolbar />}>
      <TextInput
        source="internalCode"
        label="Code interne"
        placeholder="Entrez le code interne du prestataire"
        validate={[required("Le code interne est requis")]}
      />
      <TextInput
        source="name"
        label="Nom du prestataire"
        placeholder="Entrez le nom du prestataire"
        validate={[required("Le nom du prestataire est requis")]}
      />
      <TextInput
        source="address"
        label="Adresse"
        placeholder="Entrez l'adresse du prestataire"
        validate={[required("L'adresse est requise")]}
      />
      <TextInput
        source="email"
        label="Email"
        placeholder="Entrez l'email du prestataire"
        validate={[required("L'email est requis")]}
      />
    </SimpleForm>
  </Create>
);
